import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
// import { fetchAllLogs } from "../features/settings/settingsSlice";
import { BeatLoader } from "react-spinners";

const override = {
  display: "block",
  margin: "0 auto",
  textAlign: "center",
  padding: "20px",
};

function Logs() {
  const dispatch = useDispatch();

  const { assistant } = useParams();

  const { logs, loading } = useSelector((state) => state.setting);

  useEffect(() => {
    if (!assistant) return;

    const fetchData = async () => {
      try {
        // const assistantId = assistant;
        // await dispatch(fetchAllLogs({ uuid: assistantId })).unwrap();
      } catch (error) {
        console.error("Failed to fetch setting details:", error);
      }
    };

    fetchData();
  }, [assistant, dispatch]);

  return (
    <div className="content">
      <div className="row">
        <div className="card border p-0 mt-4 w-100">
          <div className="card-header p-4 border-bottom bg-body">
            <h3 className="mb-0">Logs</h3>
          </div>

          <div className="card-body p-3">
            {loading ? (
              <BeatLoader
                loading={true}
                cssOverride={override}
                color="var(--phoenix-emphasis-color)"
                size="10px"
              />
            ) : (
              <div className="accordion" id="logsAccordion">
                {!logs || Object.keys(logs).length === 0 ? (
                  <div className="text-center text-muted py-4">
                    No logs found
                  </div>
                ) : (
                  Object.entries(logs).map(
                    ([conversationId, messages], index) => {
                      const headingId = `heading-${index}`;
                      const collapseId = `collapse-${index}`;

                      return (
                        <div
                          className="accordion-item border-top"
                          key={conversationId}
                        >
                          <h2 className="accordion-header" id={headingId}>
                            <button
                              className={`accordion-button d-flex align-items-center ${
                                index !== 0 ? "collapsed" : ""
                              }`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#${collapseId}`}
                              aria-expanded={index === 0}
                              aria-controls={collapseId}
                            >
                              <span>{conversationId}</span>
                            </button>
                          </h2>

                          <div
                            id={collapseId}
                            className={`accordion-collapse collapse ${
                              index === 0 ? "show" : ""
                            }`}
                            aria-labelledby={headingId}
                            data-bs-parent="#logsAccordion"
                          >
                            <div className="accordion-body pt-2">
                              {messages.length === 0 ? (
                                <div className="text-muted small">
                                  No messages found for this conversation
                                </div>
                              ) : (
                                messages.map((msg) => (
                                  <div
                                    key={msg.messageId}
                                    className="border rounded p-3 mb-3"
                                  >
                                    <div className="fw-semibold mb-2">
                                      Message ID:
                                      <span className="ms-2 text-primary">
                                        {msg.messageId}
                                      </span>
                                    </div>

                                    {msg.steps.map((step, stepIndex) => (
                                      <div
                                        key={stepIndex}
                                        className="border-start ps-3 mb-2"
                                      >
                                        <div className="fw-semibold">
                                          {step.source}
                                        </div>

                                        {step.transcriberText && (
                                          <div>
                                            <strong>Transcriber Text:</strong>{" "}
                                            {step.transcriberText}
                                          </div>
                                        )}

                                        {step.improvedMessage && (
                                          <div>
                                            <strong>Improved Message:</strong>{" "}
                                            {step.improvedMessage}
                                          </div>
                                        )}

                                        {step.message && (
                                          <div>
                                            <strong>Message:</strong>{" "}
                                            {step.message}
                                          </div>
                                        )}

                                        {step.rejectionReason && (
                                          <div className="text-warning">
                                            <strong>Spam:</strong>{" "}
                                            {step.rejectionReason} (score:{" "}
                                            {step.score})
                                          </div>
                                        )}

                                        {step.toolCalled && (
                                          <div>
                                            <strong>Tool:</strong>{" "}
                                            {step.toolCalled}
                                          </div>
                                        )}

                                        {step.query && (
                                          <div>
                                            <strong>Search Query:</strong>{" "}
                                            {step.query}
                                          </div>
                                        )}

                                        {step.response && (
                                          <div>
                                            <strong>Typesene Response:</strong>{" "}
                                            {step.response}
                                          </div>
                                        )}

                                        {step.extractedEntities && (
                                          <div>
                                            <strong>Entities:</strong>{" "}
                                            {step.extractedEntities}
                                          </div>
                                        )}

                                        {step.errorCode && (
                                          <div className="text-danger">
                                            <strong>
                                              Error {step.errorCode}:
                                            </strong>{" "}
                                            {step.reason}
                                          </div>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                ))
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    },
                  )
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Logs;
